import Transition from '@ember/routing/-private/transition';
import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import BillingService from 'cio/services/billing';
import StripeV3Service from 'ember-stripe-elements/services/stripev3';

export default class CheckoutRoute extends Route {
  crumb() {
    return {
      name: 'Checkout',
      path: this.routeName,
    };
  }

  @service('stripev3') stripe!: StripeV3Service;
  @service billing!: BillingService;

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);
    return this.stripe.load();
  }

  setupController(params: any) {
    // initialization of billing service returns an empty promise - actual data is available on service instance
    return this.billing.initialize({ refresh: true, paramPlanSlug: params.plan, code: params.code });
  }
}
